import axios from "axios";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/v1`,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("nl_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  try {
    let vid = localStorage.getItem("nl_vid");
    if (!vid) {
      vid = Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
      localStorage.setItem("nl_vid", vid);
    }
    config.headers["X-Device-Id"] = vid;
  } catch { /* storage unavailable */ }
  return config;
});

export function timeAgo(iso?: string | null): string {
  if (!iso) return "";
  return dayjs(iso).fromNow();
}

export function formatDate(iso?: string | null): string {
  if (!iso) return "—";
  return dayjs(iso).format("MMM D, YYYY HH:mm");
}

export function slugifyName(name: string): string {
  return (name || "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
}

export function apiError(e: any): string {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((d: any) => (d && typeof d.msg === "string" ? d.msg : JSON.stringify(d))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
